export const CALENDLY_STYLESHEET_SOURCE =
  "https://assets.calendly.com/assets/external/widget.css";
